import { render } from "./DataPernyataanView.vue?vue&type=template&id=79d44b83"
import script from "./DataPernyataanView.vue?vue&type=script&lang=js"
export * from "./DataPernyataanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__